import cn from 'classnames';
import styles from './stlyes.module.scss';

export const STATUSES_MAP = {
  '': 'Не выбран',
  false: 'Не заполнена',
  true: "Заполнена",
};

const ProductContentStatus = ({ contentStatus = false }) => {
  return (

    <div className={cn(styles.status, contentStatus == true && styles.succes, contentStatus == false && styles.error)}>
      {STATUSES_MAP[contentStatus]}
    </div>
  );
};

export default ProductContentStatus;
